// CR-2: public joining form opened from the rejoin link (/exit-rejoin-form/:token). No login;
// the token is the credential, the form is pre-filled with data on file, and it can be submitted once.
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Field, ReadField } from "./ExitParts";
import { exitApi, fmtDate } from "./exitApi";

const FIELD_TYPES = { date_of_birth: "date", preferred_joining_date: "date", address: "textarea", remarks: "textarea" };

export default function ExitRejoinForm() {
  const { token } = useParams();
  const [form, setForm] = useState(null);
  const [vals, setVals] = useState({});
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    exitApi
      .rejoinForm(token)
      .then((res) => {
        setForm(res.data);
        setVals(res.data.values || {});
      })
      .catch((e) => setError(e.message));
  }, [token]);

  const set = (k, v) => {
    setVals((x) => ({ ...x, [k]: v }));
    setErrors((x) => ({ ...x, [k]: undefined }));
  };

  const submit = async () => {
    const missing = Object.fromEntries(
      form.fields.filter((f) => f.required && !String(vals[f.key] || "").trim()).map((f) => [f.key, "Required"])
    );
    if (Object.keys(missing).length) {
      setErrors(missing);
      return;
    }
    setBusy(true);
    try {
      await exitApi.rejoinFormSubmit(token, vals);
      setDone(true);
    } catch (e) {
      if (e.details && Object.keys(e.details).length) setErrors(e.details);
      else setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  const prev = form?.previous_employment || {};
  return (
    <div className="exitwf" style={{ maxWidth: 960, margin: "0 auto", minHeight: "100vh" }}>
      <div className="exitwf-head">
        <h3>Joining Form</h3>
      </div>
      {error ? (
        <Card><p style={{ margin: 0 }}>{error}</p></Card>
      ) : done ? (
        <Card><p style={{ margin: 0 }}>Thank you. Your joining form has been submitted and HR will contact you.</p></Card>
      ) : !form ? (
        <Card><p style={{ margin: 0 }}>Loading...</p></Card>
      ) : (
        <>
          <Card title="Previous Employment">
            <div className="exitwf-grid">
              <ReadField label="Employee Code" value={prev.employee_code} />
              <ReadField label="Designation" value={prev.designation} />
              <ReadField label="Project" value={prev.project} />
              <ReadField label="Date of Joining" value={fmtDate(prev.date_of_joining)} />
              <ReadField label="Date of Leaving" value={fmtDate(prev.date_of_leaving)} />
            </div>
          </Card>
          <Card title="Your Details">
            <div className="exitwf-grid">
              {form.fields.map((f) => (
                <Field key={f.key} field={{ ...f, type: FIELD_TYPES[f.key] || "text" }} value={vals[f.key]}
                  onChange={set} error={errors[f.key]} readOnly={busy} />
              ))}
            </div>
            <div className="exitwf-actions">
              <button className="exitwf-btn" disabled={busy} onClick={submit}>{busy ? "Submitting..." : "Submit"}</button>
            </div>
          </Card>
        </>
      )}
    </div>
  );
}
